import IpubUploadInput from './src/main'

/* istanbul ignore next */
IpubUploadInput.install = function(Vue) {
  Vue.component(IpubUploadInput.name, IpubUploadInput)
}

export default IpubUploadInput
